/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendOtherOpexDto } from '../../models/backend-other-opex-dto';

export interface OpexesOtheropexCopyCreate$Params {
  id: number;
}

export function opexesOtheropexCopyCreate(
  http: HttpClient,
  rootUrl: string,
  params: OpexesOtheropexCopyCreate$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendOtherOpexDto>> {
  const rb = new RequestBuilder(rootUrl, opexesOtheropexCopyCreate.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendOtherOpexDto>;
    }),
  );
}

opexesOtheropexCopyCreate.PATH = '/api/opexes/otheropex/{id}/copy/';
